import {OrgWalletTransactionDto} from "./org-wallet-transaction.dto";
import {PaymentProvider} from "../../libs/enum/payment-provider.enum";
import {isDefined} from "../../libs/utils/epic.utils";

export class OrgWalletDto {

  public readonly id!: string;
  public readonly netAmount!: number;
  public readonly currencyCode!: string;
  public readonly updated!: Date;
  public readonly currentTransaction: OrgWalletTransactionDto | undefined;
  public readonly paymentProviders: PaymentProvider[] = [];

  constructor(init?: Partial<OrgWalletDto> | undefined) {
    Object.assign(this, init);
    if (init?.updated) {
      this.updated = new Date(init.updated);
    }
    if (isDefined(init?.currentTransaction)) {
      this.currentTransaction = new OrgWalletTransactionDto(init?.currentTransaction);
    }
  }
}
